// extracted by mini-css-extract-plugin
export default {"signup-container":"style_signup-container__Q6YYk","signup-form":"style_signup-form__Sg4mP","error-message":"style_error-message__KrBUw"};